<template>
  <tr>
    <td>{{ this.$vnode.key + 1 }}</td>
    <td v-if="isPC">
      <b>{{ name }}</b>
    </td>
    <td v-if="isPC">
      {{ location.building }}
      <br />
      <b>{{ location.mall }}</b>
      <br />
      <a-badge
        :count="`${location.floor}층 ${location.row}열 ${location.place}호`"
        :numberStyle="{ backgroundColor: '#52c41a' }"
      />
    </td>
    <td v-if="isPC">
      <a-input-number
        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
        :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
        v-model="saib.price"
        @change="onUpdate"
      />
      <span style="margin-left: 6px">원</span>
    </td>
    <td v-if="isPC" class="order-detail">
      <div v-for="(detail, index) in saib.details" :key="index">
        <a-input
          size="small"
          style="width: 120px; margin-right: 10px; margin-top: 10px;"
          placeholder="품목/컬러/사이즈"
          @keypress="onUpdate"
          v-model="saib.details[index].name"
        />
        <a-input-number
          :formatter="
            (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          size="small"
          style="width: 50px; margin-right: 10px;"
          placeholder="수량"
          @keypress="onUpdate"
          v-model="saib.details[index].amount"
        />
        <a-button
          size="small"
          shape="circle"
          type="link"
          icon="minus-circle"
          @click="decrease(index)"
        />
      </div>
      <a-button
        style="width: 190px; margin-top: 10px;"
        type="dashed"
        size="small"
        icon="plus"
        @click="increase"
        block
        >추가</a-button
      >
    </td>
    <td v-if="!isPC" class="detail" style="text-align: left;">
      <dl>
        <dt>매장 이름:</dt>
        <dd>{{ name }}</dd>
        <dt>위치:</dt>
        <dd>{{ location.building }} ({{ location.mall }})</dd>
        <dt>층/열/호:</dt>
        <dd>
          {{ `${location.floor}층 ${location.row}열 ${location.place}호` }}
        </dd>
        <dt>예상 금액:</dt>
        <dd>
          <a-input-number
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            v-model="saib.price"
            @change="onUpdate"
          />
          <span style="margin-left: 6px">원</span>
        </dd>
        <dt>주문내역:</dt>
        <dd class="order_item">
          <div v-for="(detail, index) in saib.details" :key="index">
            <a-input
              size="small"
              style="width: 120px; margin-right: 10px; margin-top: 10px;"
              placeholder="품목/컬러/사이즈"
              @keypress="onUpdate"
              v-model="saib.details[index].name"
            />
            <a-input-number
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
              size="small"
              style="width: 50px; margin-right: 10px;"
              placeholder="수량"
              @keypress="onUpdate"
              v-model="saib.details[index].amount"
            />
            <a-button
              size="small"
              shape="circle"
              type="link"
              icon="minus-circle"
              @click="decrease(index)"
            />
          </div>
          <a-button
            style="width: 190px; margin-top: 10px;"
            type="dashed"
            size="small"
            icon="plus"
            @click="increase"
            block
            >추가</a-button
          >
        </dd>
      </dl>
    </td>
  </tr>
</template>
<script>
  import config from '../../config';
  import { TYPES } from '../../stores/saib';
  export default {
    name: 'SaibApplyItem',
    props: ['idx', 'wholesale', 'name', 'location', 'details', 'price'],
    data() {
      return {
        key: this.$vnode.key,
        saib: {
          idx: this.idx,
          price: this.price,
          details: this.details,
        },
      };
    },
    methods: {
      onUpdate() {
        const { key, saib } = this;
        this.$store.commit(TYPES.UPDATE_DETAILS, { key, saib });
      },
      increase() {
        this.saib.details.push({
          name: '',
          amount: 1,
        });
        this.onUpdate();
      },
      decrease(idx) {
        if (this.saib.details.length <= 1) {
          return config.alert.mixin({
            type: 'error',
            title: '주문 내역은 최소 1개 이상이여야 합니다.',
          });
        }

        this.saib.details.splice(idx, 1);
        this.onUpdate();
      },
    },
  };
</script>
